/* unplugin-vue-components disabled */import { render } from "./NewsInformation.vue?vue&type=template&id=09b56109&scoped=true"
import script from "./NewsInformation.vue?vue&type=script&lang=js"
export * from "./NewsInformation.vue?vue&type=script&lang=js"

import "./NewsInformation.vue?vue&type=style&index=0&id=09b56109&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b56109"]])

export default __exports__